import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { DialogFormActionsComponent } from '../common';
import { TranslateModule } from '@ngx-translate/core';
import { TracesProduct } from '../model';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  templateUrl: 'traces-dds-confirm-retract-dialog.component.html',
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    MatCheckboxModule,
    FormsModule,
    DialogFormActionsComponent,
    TranslateModule,
  ],
})
export class TracesDdsConfirmRetractDialogComponent {
  readonly data = inject<{ product: TracesProduct }>(MAT_DIALOG_DATA);
  confirmed = false;
}
